import { jsx as r, jsxs as l } from "react/jsx-runtime";
import d from "classnames";
import c from "../../utils/colors.js";
import { f as k } from "../../styled-qu50FBLM.mjs";
import { Svg as m, GElement as e, Line as o, Path as h, Elipse as x } from "./Elements.js";
const W = ({
  className: s = "",
  fill: t = c.orange,
  viewBox: n = "0 0 42 52",
  $cssHelper: i = k,
  focusable: a
}) => /* @__PURE__ */ r(
  m,
  {
    className: d({ [s]: !!s }),
    viewBox: n,
    $cssHelper: i,
    focusable: !!a,
    "aria-hidden": !a,
    children: /* @__PURE__ */ r(e, { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ r(e, { transform: "translate(-19.000000, -847.000000)", children: /* @__PURE__ */ r(e, { transform: "translate(20.000000, 848.000000)", children: /* @__PURE__ */ l(e, { children: [
      /* @__PURE__ */ r(
        o,
        {
          x1: "20",
          y1: "0",
          x2: "20",
          y2: "8.62068966",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "square"
        }
      ),
      /* @__PURE__ */ r(
        o,
        {
          x1: "20",
          y1: "41.3793103",
          x2: "20",
          y2: "50",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "square"
        }
      ),
      /* @__PURE__ */ r(
        o,
        {
          x1: "35.5102041",
          y1: "20.9183673",
          x2: "35.5102041",
          y2: "29.0816327",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "square",
          transform: "translate(35.510204, 25.000000) rotate(90.000000) translate(-35.510204, -25.000000) "
        }
      ),
      /* @__PURE__ */ r(
        o,
        {
          x1: "4.48979592",
          y1: "20.9183673",
          x2: "4.48979592",
          y2: "29.0816327",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "square",
          transform: "translate(4.489796, 25.000000) rotate(90.000000) translate(-4.489796, -25.000000) "
        }
      ),
      /* @__PURE__ */ r(
        e,
        {
          transform: "translate(11.836735, 16.379310)",
          fill: t,
          fillRule: "nonzero",
          children: /* @__PURE__ */ r(h, { d: "M8.16326531,10.7758621 C10.8877551,10.7758621 16.3265306,12.2198276 16.3265306,15.0862069 L16.3265306,15.0862069 L16.3265306,17.2413793 L0,17.2413793 L0,15.0862069 C0,12.2198276 5.43877551,10.7758621 8.16326531,10.7758621 Z M8.16326531,0 C10.4174888,0 12.244898,1.92980711 12.244898,4.31034483 C12.244898,6.69088254 10.4174888,8.62068966 8.16326531,8.62068966 C5.90904184,8.62068966 4.08163265,6.69088254 4.08163265,4.31034483 C4.08163265,1.92980711 5.90904184,0 8.16326531,0 Z" })
        }
      ),
      /* @__PURE__ */ r(
        x,
        {
          stroke: "#E3710A",
          strokeWidth: "3",
          cx: "20",
          cy: "25",
          rx: "15.5102041",
          ry: "20.6896552"
        }
      )
    ] }) }) }) })
  }
);
export {
  W as default
};
